export default Object.freeze({
  name: 'development',
  prod: false,
  'storage-prefix': 'e5p-test',
  api: {
    'REST-URL': window.configEnv.APP_REST_URL,
    'REST-URL-STATIC': window.configEnv.APP_REST_URL_STATIC,
    'GRAPHQL-URI': window.configEnv.APP_GRAPHQL_URI,
  },
});
